/**
 * File Name          : blink-pattern-help.component.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.1.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_PROJECTTECH_LICENSE.txt', which is part of this source code package.
 */

import { Component } from '@angular/core';
import { SensorColorComponent } from "../../icons/sensor-color/sensor-color.component";
import { SENSOR_LED_PATTERN as LED_PATTERNS } from "../../icons/sensor-color/sensor-color.component";

@Component({
  selector: 'app-blink-pattern-help',
  standalone: true,
  imports: [SensorColorComponent],
  templateUrl: './blink-pattern-help.component.html',
  styleUrl: './blink-pattern-help.component.scss'
})
export class BlinkPatternHelpComponent {
  LED_PATTERNS = LED_PATTERNS;
}
